<template>
    <div class="autocomplete-suggestions__item">
        <div v-html="highlightSuggestion"></div>
        <template v-if="suggestion.secondaryValue"
            >, <span>{{ suggestion.secondaryValue }}</span></template
        >
    </div>
</template>

<script setup lang="ts">
    import { ProductInterface } from './models/SuggestionInterface.ts';
    import { computed } from 'vue';

    const props = defineProps<{
        suggestion: ProductInterface;
        query: String;
    }>();

    const highlightSuggestion = computed(() => {
        if (props.suggestion.value_highlighting) {
            return props.suggestion.value_highlighting;
        }

        return props.suggestion.mainValue.replace(
            new RegExp(props.query, 'gi'),
            (match) => {
                return ' <strong>' + match + '</strong>';
            }
        );
    });
</script>

<style lang="less">
    .autocomplete-suggestions__item {
        padding: 10px;
        background-color: #fff;
        display: flex;

        &:hover {
            background-color: #e1e1e1;
            cursor: pointer;
        }

        strong {
            font-weight: 700;
            display: inline-block;
        }

        span {
            margin-left: 3px;
            display: block;
        }
    }
</style>
